// import React, { Suspense, lazy } from "react";
// import { Routes, Route, Navigate } from "react-router-dom";
// import Sidebar from "../../../components/Sidebar";
// import SuspensePageLoading from "../../../components/SuspensePageLoading";
// import { links } from "./links";
// import InfluencerDetail from "../../../pages/InfluencerDetail";
// import Influencers from "../../../pages/Influencers";
// import ProfileContainer from "../../../components/ProfileContainer";
// import { useSelector } from "react-redux";

// import InfluencerRoutes from "../Influencer"
// import { ACTIVE, USER_ACTIVE } from "../../../constants";
// import Success from "../../../pages/Success";
// import Rejected from "../../../pages/Rejected";
// import FavoriteInfluencers from "../../../pages/FavoriteInfluencers";
// import Subscription from "../../../pages/Subscription";


// const Dashboard = lazy(() => import("../../../pages/Dashboard/Agency"));
// const Discovery = lazy(() => import("../../../pages/Discovery"));
// const Campaign = lazy(() => import("../../../pages/Campaign"));
// const CreateCampaign = lazy(() => import("../../../pages/CreateCampaign"));
// const Profile = lazy(() => import("../../../pages/Profile/Agency"));
// const CampaignDetail = lazy(() => import("../../../pages/CampaignDetail"))
// const DeliverableReview = lazy(() => import("../../../pages/DeliverableReview"))
// const DeliverableDetail = lazy(() => import("../../../pages/DeliverableDetail"));
// const Pricing = lazy(() => import("../../../pages/Pricing"));



// const AgencyRoutes = () => {
//   const is_influencer_selected = useSelector(state => state.influencer_profile.active);
//   const user = useSelector(state => state.user);

//   return (
//     <ProfileContainer>
//       {
//         is_influencer_selected ?
//           <>
//             <InfluencerRoutes />
//           </>
//           :
//           <>
//             {(user?.subscription?.status === USER_ACTIVE.value || user?.subscription?.status === "canceled") && <Sidebar links={links} />}
//             <Suspense fallback={<SuspensePageLoading />}>
//               {
//                 user?.subscription?.status === USER_ACTIVE.value || user?.subscription?.status === "canceled" ?
//                 <Routes>
//                 <Route path="/" element={<Dashboard />} />
//                 <Route path="/discovery" element={<Discovery />} />
//                 <Route path="/campaign" element={<Campaign />} />
//                 <Route path="/campaign/:id" element={<CampaignDetail />} />
//                 <Route path="/campaign/:id/deliverable/:deliverableId" element={<DeliverableDetail />} />
//                 {/* <Route path="/campaign/:id/deliverable/:deliverableId/review" element={<DeliverableReview/>} /> */}
//                 <Route path="/campaign/create" element={<CreateCampaign />} />
//                 <Route path="/influencer/:id" element={<InfluencerDetail />} />
//                 <Route path="/influencers" element={<Influencers />} />
//                 <Route path="/profile" element={<Profile />} />
//                 <Route path="/pricing" element={<Pricing renew={true}/>} />
//                 <Route path="/favorite-influencers" element={<FavoriteInfluencers/>} />
//                   <Route path="/success" element={<Success />} />
//                   <Route path="/reject" element={<Rejected />} />
//               <Route path="/subscription" element={<Subscription />} />
//                 <Route path="*" element={<Navigate to="/" />} />
//               </Routes>


//                   :
//                   <Routes>
//                   <Route path="/pricing" element={<Pricing renew={false}/>} />
//                   <Route path="/success" element={<Success />} />
//                   <Route path="/reject" element={<Rejected />} />


//                   <Route path="*" element={<Navigate to="/pricing" />} />
//                 </Routes>


//               }

//             </Suspense>
//           </>
//       }
//     </ProfileContainer>
//   );
// };

// export default AgencyRoutes;



import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import SuspensePageLoading from "../../../components/SuspensePageLoading";
import { links } from "./links";
import InfluencerDetail from "../../../pages/InfluencerDetail";
import Influencers from "../../../pages/Influencers";
import ProfileContainer from "../../../components/ProfileContainer";
import { useDispatch, useSelector } from "react-redux";
import ChatBot from "../../../components/ChatBot";


import InfluencerRoutes from "../Influencer"
import Subscription from "../../../pages/Subscription";
import FavoriteInfluencers from "../../../pages/FavoriteInfluencers";
import SubscriptionBanner from "../../../components/SubscriptionBanner";
import { UpdatePlan } from "../../../components/UpdatePlan";
import { RiMenu5Fill } from "react-icons/ri";
import { set_sidebar } from "../../../redux/slices/uiSlice";
import Pricing from "../../../pages/Pricing";
import Success from "../../../pages/Success";
import Rejected from "../../../pages/Rejected";
import { USER_ACTIVE } from "../../../constants";
import NotificationSidebar from "../../../components/NotificationSidebar";
import RequireSubscription from "../../../components/RequireSubscription";
import Notifications from "../../../pages/Notifications";
import CheckSubscriptionWrapper from "../../../components/CheckSubscriptionWrapper";
import AiSuggestions from "../../../pages/AiSuggestions";
import InfluencerRecap from "../../../pages/InfluencerRecap";
import AiSearch from "../../../pages/AiSearch";


const Dashboard = lazy(() => import("../../../pages/Dashboard/Agency"));
const Discovery = lazy(() => import("../../../pages/Discovery"));
const Campaign = lazy(() => import("../../../pages/Campaign"));
const CreateCampaign = lazy(() => import("../../../pages/CreateCampaign"));
const Profile = lazy(() => import("../../../pages/Profile/Agency"));
const CampaignDetail = lazy(() => import("../../../pages/CampaignDetail"))
const DeliverableReview = lazy(() => import("../../../pages/DeliverableReview"))
const DeliverableDetail = lazy(() => import("../../../pages/DeliverableDetail"));
const Chats = lazy(() => import("../../../pages/Chats"));
const FinancialRecap = lazy(() => import("../../../pages/FinancialRecap"));
const CampaignRecap = lazy(() => import("../../../pages/CampaignRecap"));



const AgencyRoutes = () => {
  const is_influencer_selected = useSelector(state => state.influencer_profile.active);
  const user = useSelector(state => state.user);
  const { sidebar } = useSelector(state => state.ui);
  const dispatch = useDispatch();

  const location = useLocation();
  console.log("location",location.pathname)

  return (
    
    <ProfileContainer>
      <CheckSubscriptionWrapper>
      {/* {
        user?.free_subscription?.is_paid === "paid" && !is_influencer_selected && !(location.pathname === "/pricing" || location.pathname === "/success" || location.pathname === "/reject" || location.pathname === "/recommendations") && <ChatBot/>
       } */}
      {
        !(location.pathname === "/pricing" || location.pathname === "/success" || location.pathname === "/reject") && <SubscriptionBanner />
      }
      {
        is_influencer_selected ?
          <>
            <InfluencerRoutes />
          </>
          :
          <>
          
      
      {!(location.pathname === "/pricing" || location.pathname === "/success" || location.pathname === "/reject") && <><Sidebar links={links} /><NotificationSidebar /></> }
            <Suspense fallback={<SuspensePageLoading />}>
            
              <Routes>
                {
                  // user?.subscription?.status === USER_ACTIVE.value || user?.subscription?.status === "canceled" ?
                  user?.free_subscription?.is_paid === "paid" ?
                  
                    <>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/discovery" element={<Discovery />} />
                      <Route path="/campaign" element={<Campaign />} />
                      <Route path="/influencer/:id" element={<InfluencerDetail />} />
                      <Route path="/favorite-influencers" element={<FavoriteInfluencers />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/pricing" element={<Pricing renew={true} />} />
                      <Route path="/success" element={<Success />} />
                      <Route path="/reject" element={<Rejected />} />


                      <Route path="/subscription" element={<Subscription />} />
                      {/* <Route path="/notifications" element={<Notifications />} /> */}
                      
                      
                      <Route path="/campaign/:id/chats" element={<CheckSubscriptionWrapper><Chats /></CheckSubscriptionWrapper>} />
                      <Route path="/ai-search" element={<CheckSubscriptionWrapper><AiSearch /></CheckSubscriptionWrapper>} />
                      <Route path="/financial-recap" element={<CheckSubscriptionWrapper><FinancialRecap /></CheckSubscriptionWrapper>} />
                      <Route path="/campaign-recap" element={<CheckSubscriptionWrapper><CampaignRecap /></CheckSubscriptionWrapper>} />
                      <Route path="/campaign/:id" element={<CheckSubscriptionWrapper><CampaignDetail /></CheckSubscriptionWrapper>} />
                      <Route path="/influencer-recap" element={<CheckSubscriptionWrapper><InfluencerRecap /></CheckSubscriptionWrapper>} />
                      <Route path="/recommendations" element={<CheckSubscriptionWrapper><AiSuggestions /></CheckSubscriptionWrapper>} />
                      <Route path="/campaign/:id/deliverable/:deliverableId" element={<CheckSubscriptionWrapper><DeliverableDetail /></CheckSubscriptionWrapper>} />
                      {/* <Route path="/campaign/:id/deliverable/:deliverableId/review" element={<DeliverableReview/>} /> */}
                      <Route path="/campaign/create" element={<CheckSubscriptionWrapper><CreateCampaign /></CheckSubscriptionWrapper>} />
                      <Route path="/influencers" element={<CheckSubscriptionWrapper><Influencers /></CheckSubscriptionWrapper>} />
                      <Route path="/subscription" element={<CheckSubscriptionWrapper><Subscription /></CheckSubscriptionWrapper>} />


                      <Route path="*" element={<Navigate to="/" />} />
                      
                    </>


                    : user?.free_subscription?.is_paid === "free" ?
                      <>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/discovery" element={<Discovery />} />
                        <Route path="/influencer/:id" element={<InfluencerDetail />} />
                        <Route path="/favorite-influencers" element={<FavoriteInfluencers />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/subscription" element={<Subscription />} />
                        <Route path="/pricing" element={<Pricing renew={true} />} />
                        <Route path="/success" element={<Success />} />
                        <Route path="/reject" element={<Rejected />} />
                      

                        <Route path="/ai-search" element={<RequireSubscription />} />
                        <Route
                          path="/campaign"
                          element={
                            // <div className={`${sidebar ? "lg:pl-[230px]" : "pl-0"} h-[100vh] relative overflow-y-hidden flex flex-col justify-center bg-base-bg items-center px-4`}>
                            //   {
                            //     !sidebar &&
                            //     <button
                            //       onClick={() => {
                            //         dispatch(set_sidebar(true))
                            //       }}
                            //       type="button"
                            //       className='mr-5 h-[40px] w-[40px] rounded-full absolute top-5 left-5 transition-all hover:bg-primary/5 flex items-center justify-center'
                            //     >
                            //       <RiMenu5Fill className='text-t-light text-xl' />
                            //     </button>
                            //   }
                            //   <UpdatePlan />
                            // </div>
                            <RequireSubscription />
                          }
                        />
                        <Route
                          path="/recommendations"
                          element={
                            <RequireSubscription />
                          }
                        />
                        <Route
                          path="/campaign/:id"
                          element={
                            <RequireSubscription />

                          }
                        />
                        <Route
                          path="/chats"
                          element={
                            <RequireSubscription />

                          }
                        />
                        <Route
                          path="/campaign/:id/deliverable/:deliverableId"
                          element={
                            <RequireSubscription />

                          }
                        />
                        <Route
                          path="/campaign/create"
                          element={
                            <RequireSubscription />

                          }
                        />
                        <Route
                          path="/influencers"
                          element={
                            <RequireSubscription />
                          }
                        />
                         {/* <Route
                          path="/notifications"
                          element={
                            <RequireSubscription />
                          }
                        /> */}
                        <Route
                          path="/financial-recap"
                          element={
                            <RequireSubscription />
                          }
                        />
                        <Route
                          path="/influencer-recap"
                          element={
                            <RequireSubscription />
                          }
                        />
                        <Route
                          path="/campaign-recap"
                          element={
                            <RequireSubscription />
                          }
                        />
                      </>
                      :

                      <><Route path="/pricing" element={<Pricing renew={false} />} /><Route path="/success" element={<Success />} /><Route path="/reject" element={<Rejected />} /><Route path="*" element={<Navigate to="/pricing" />} /></>



                }



                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Suspense>
          </>
      }
      </CheckSubscriptionWrapper>
    </ProfileContainer>
  );
};

export default AgencyRoutes;

